import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import type {
    GenericResponse,
    SetBlockStatusRequest,
    CancelCardRequest,
    ActivateCardRequest,
} from '@/features/card/types/card.types';
import { buildCommonHeaders } from '@/shared/http/commonHeaders';



export const cardService = {
    async blockCard(payload: SetBlockStatusRequest): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.card.block, { data: { data: payload } }, { headers: newHeaders });
        return response.data;
    },

    async unblockCard(payload: SetBlockStatusRequest): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.card.unblock, { data: { data: payload } }, { headers: newHeaders });
        return response.data;
    },

    async cancelCard(payload: CancelCardRequest): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: {},
                    response: 'OK'
                });
            }, 100);
        });
        return apiClient.post<GenericResponse>(API_ENDPOINTS.card.cancel, payload, { headers: newHeaders });
    },

    async activateCard(payload: ActivateCardRequest): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        return apiClient.post<GenericResponse>(API_ENDPOINTS.account.create, { data: { data: payload } }, { headers: newHeaders });
    }
};
